import { useCallback, useEffect, useState } from 'react';
import { useFileInput } from '@gravity-ui/uikit';

import { useInfoUserQuery, useUploadAvatarMutation } from 'store/api/private';
import type { User } from 'store/api/private/user-api/types';

export const usePhotoUpload = (data: User) => {
	const [imageSrc, setImageSrc] = useState('');
	const [uploadAvatar] = useUploadAvatarMutation();

	const { refetch } = useInfoUserQuery(null);

	useEffect(() => {
		if (data?.imageUrl) {
			const timestamp = new Date().getTime();
			const imageUrlWithTimestamp = `${data.imageUrl}?t=${timestamp}`;
			setImageSrc(imageUrlWithTimestamp);
			console.log('imageSrc обновлён из data.imageUrl с меткой времени:', imageUrlWithTimestamp);
		}
	}, [data]);

	const handleFileUpload = async (file: File) => {
		if (!data) {
			return;
		}
		try {
			const uploadResult = await uploadAvatar({ id: data.id, photo: file }).unwrap();

			const timestamp = new Date().getTime();
			const imageUrlWithTimestamp = `${uploadResult}?t=${timestamp}`;

			setImageSrc(imageUrlWithTimestamp);

			console.log('Обновление imageSrc из ответа сервера:', imageUrlWithTimestamp);

			refetch();
		} catch (error) {
			console.error(error);
		}
	};

	const onUpdate = useCallback(
		async (files: File[]) => {
			const file = files[0];
			if (file) {
				await handleFileUpload(file);
			} else {
				console.error('No file selected');
			}
		},
		[handleFileUpload],
	);
	const { controlProps, triggerProps } = useFileInput({ onUpdate });

	const handleImageClick = () => {
		const input = document.getElementById('file-input');
		if (input) {
			input.click();
		}
	};

	return {
		imageSrc,
		onUpdate,
		setImageSrc,
		handleFileUpload,
		handleImageClick,
		controlProps,
		triggerProps,
	};
};
